var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
export const Divider = React.forwardRef((_a, ref) => {
    var { alignContent, children, className, el, spacing = 0, vertical } = _a, props = __rest(_a, ["alignContent", "children", "className", "el", "spacing", "vertical"]);
    const DividerElement = el
        ? el
        : children
            ? 'div'
            : vertical
                ? 'span'
                : 'hr';
    const DividerClasses = classnames('Divider', className, {
        'Divider--has-children': children && el !== 'hr',
        [`Divider--spacing-${spacing}`]: spacing,
        'Divider--vertical': vertical,
    });
    const line = React.createElement("div", { className: "Divider__line" });
    return (React.createElement(DividerElement, Object.assign({ ref: ref, className: DividerClasses, "data-anvil-component": "Divider" }, props), children && el !== 'hr' ? (React.createElement(React.Fragment, null,
        alignContent === 'start' ? null : line,
        React.createElement("div", { className: "Divider__content" }, children),
        alignContent === 'end' ? null : line)) : null));
});
//# sourceMappingURL=Divider.js.map